import {endpoint} from '~/api';

export const fetchRillIframeSrc = (resourceId?: number, asUserId?: number) => {
  const params = new URLSearchParams();
  if (resourceId != null) params.set('resourceId', String(resourceId));
  if (asUserId != null) params.set('asUserId', String(asUserId));
  const query = params.toString();
  return endpoint.get<{iframeSrc: string}>(`/rill/iframe${query ? `?${query}` : ''}`);
};

export const fetchImpersonatableUsers = () =>
  endpoint
    .get<{items: {id: number; email: string}[]}>('/rill/impersonatable-users')
    .then(r => r.data.items);
